export const uniqBy = <T, K>(array: T[], predicate: ((item: T) => K) | keyof T): T[] => {
  if (!Array.isArray(array)) {
    return [];
  }

  const cb =
    typeof predicate === 'function'
      ? (predicate as (item: T) => K)
      : (o: T) => o[predicate] as unknown as K;

  const pickedObjects = array
    .reduce((map, item) => {
      if (item === null || item === undefined) {
        return map;
      }

      const key = cb(item);

      if (key === null || key === undefined) {
        return map;
      }

      return map.has(key) ? map : map.set(key, item);
    }, new Map<K, T>())
    .values();

  return [...pickedObjects];
};
